const { cELM, Wrap4Arrow, Wrap4ArrowRight } = require("../../utils");
const Chat = require("../../chat");
const Scroller = require("../scroller");

class YESNO {
  constructor(value, data, options = { yes: "Yes", no: "No",isHighlighted:false }) {
    this._element = null;
    this.options = options;
    this.data = data;
    this.value = value;
    this.createElement();
  }

  createElement() {
    let self = this
    //const wrapper = cELM("div", "button yes-no-block");
    const wrapper = cELM("div", "yes-no-block");
    const yes = cELM("div", "yes-no-option yes");
    yes.addELM(cELM("div", "yes-no-option-text", getLngTxt('button.yes')));
    const no = cELM("div", "yes-no-option no");
    no.addELM(cELM("div", "yes-no-option-text", getLngTxt('button.no')));

    const btnWrp = Wrap4ArrowRight(yes);
    btnWrp.addELM(no);
    wrapper.addELM(btnWrp);

    if ((this.options.yes || '').trim().toLowerCase() == (this.value || '').trim().toLowerCase()) {
      wrapper.classList.add('status-yes');
      yes.classList.add("yes-no-option-active");
      
    } else if ((this.options.no || '').trim().toLocaleLowerCase() == (this.value || '').trim().toLowerCase()) {

      wrapper.classList.add('status-no');
      no.classList.add("yes-no-option-active");
   
    }
    
    yes.onclick = function() {
      let status = wrapper.parentNode.getAttribute('status')
      if (status == 'yes') {
        wrapper.parentNode.setAttribute('status', 'unknown');
        wrapper.classList.remove('status-yes');

        yes.classList.remove("yes-no-option-active");

      } else {
        yes.classList.add("yes-no-option-active");
        no.classList.remove("yes-no-option-active");


        wrapper.parentNode.setAttribute('status', 'yes')
        wrapper.classList.add('status-yes');
        wrapper.classList.remove('status-no');
      }

      self.edit()
      self.checkAll()
    }

    no.onclick = function() {
      let status = wrapper.parentNode.getAttribute('status')
      if (status == 'no') {
        wrapper.parentNode.setAttribute('status', 'unknown');
        wrapper.classList.remove('status-no');

        no.classList.remove("yes-no-option-active");
      } else {
        yes.classList.remove("yes-no-option-active");
        no.classList.add("yes-no-option-active");

        wrapper.parentNode.setAttribute('status', 'no');
        wrapper.classList.remove('status-yes');
        wrapper.classList.add('status-no');

      }

      self.edit()
      self.checkAll()
    }


    this._elmArrow = btnWrp;
    this._element = wrapper;
  }

  getELM() {
    return this._element;
  }

  getHTML() {
    return this._element;
  }
  highlight(isHighlighted){
    if(isHighlighted)
      this._elmArrow.classList.add("arrow-active");
    else
      this._elmArrow.classList.remove("arrow-active");
  }

  checkAll(){
    const yB = document.getElementsByClassName('yes-no-option yes');
    const yN = document.getElementsByClassName('yes-no-option no');
    const yTL = document.getElementsByClassName('checkbox-option');
    let numberY = 0;
    const numberN = 0;
    for (let i = 0; i < yB.length; i++){
      if(yB[i].classList.contains('yes-no-option-active')){
        numberY += 1;
      }
    }
    if(yTL[0]){
      if(numberY === yB.length){
        yTLon = yTL[0].getAttribute('status-box');
        if (yTLon != 'yes'){
          yTL[0].classList.toggle('option-active');
          yTL[0].setAttribute('status-box', 'yes');
        }
      }else{
        yTL[0].classList.remove('option-active');
        yTL[0].setAttribute('status-box', 'no');
      }
    }
    
  }

  edit() {
    const _self = this;
    var medication =  this._element.parentNode.getAttribute('medication')
    var status = this._element.parentNode.getAttribute('status')
   
    if(this._element.parentNode.parentNode.nextHighlight)
      this._element.parentNode.parentNode.nextHighlight();

    Chat.default.send({
      action:'startEditList', 
      medication: medication, 
      status: status,
      id: _self.data.id
    })
  }
}

class EDITREMOVE {
  constructor(id, value, data, options = { edit: getLngTxt('button.edit'), remove: getLngTxt('button.delete') }) {
    this.id = id;
    this._element = null;
    this.options = options;
    this.data = data;
    this.value = value;
    this.createElement();
  }

  createElement() {
    let _self = this

    const wrapper = cELM("div", "yes-no-block");
    const edit = cELM("div", "edit-rmv-option", getLngTxt('button.edit'));
    edit.value = this.value;

    wrapper.addELM(edit);

    if(this.options.remove) {
      const remove = cELM("div", "edit-rmv-option rmv", getLngTxt('button.delete'));
      remove.value = this.value;

      const confirmPopRemoveOpts = (this.options || {}).configPopupRemove || {
        title: getLngTxt('popup.delete.medication.title'),
        content: getLngTxt('popup.delete.medication.content')
      };

      remove.onclick = function(evt) {
        const element = evt.target;
        const value = element.value;
        confirmPop(confirmPopRemoveOpts,
          function(isConfirmed) {
            if (isConfirmed) {
              element.setAttribute("disabled", true);
              element.parent;
              element.parentNode.style.display = "none";

              Chat.default.send({ 
                medication: value, 
                action: "startDelete",
                id: _self.id
              });
            } else {
            }
          }
        );
      }


      wrapper.addELM(remove);
    }

    const confirmPopEditOpts = (this.options || {}).configPopupEdit || {
      title: getLngTxt('popup.edit.medication.title'),
      content: getLngTxt('popup.edit.medication.content')
    };

    edit.onclick = function(evt) {
      const element = evt.target;
      const value = element.value;
      confirmPop(confirmPopEditOpts,
        function(isConfirmed) {
          if (isConfirmed) {
            element.setAttribute("disabled", true);
            element.parent;
            element.parentNode.style.display = "none";
            
            Chat.default.send({ 
              medication: value, 
              action: "startEdit",
              id: _self.id
            });
          } else {
          }
        }
      );
    }

    this._element = wrapper;
  }

  getELM() {
    return this._element;
  }

  getHTML() {
    return this._element;
  }
  highlight(isHighlighted){
    if(isHighlighted)
      this._elmArrow.classList.add("arrow-active");
    else
      this._elmArrow.classList.remove("arrow-active");
  }
}

class List {
  constructor({ id, options, values, type, labels }) {

    this.id = id;
    this.options = options;
    this.labels = labels;
    if (Array.isArray(values)) {
      this.data = values;
    } else {
      this.data = [];
      Object.keys(values || {}).forEach(k => this.data.push(values[k]));
    }

    if (options.alphabetical && (labels || []).length > 0) {
    

      var oldData = this.data.filter((x) => !x.isNewlyAdded).sort((x,y) => x[labels[0]] > y[labels[0]] ? 1 : -1);
      var newData = this.data.filter((x) => x.isNewlyAdded > 0).sort((x,y) => x.isNewlyAdded > y.isNewlyAdded ? 1 : -1);
    
      this.data = oldData;
      for(var i = 0; i < newData.length; i++){
        this.data.push(newData[i]);
      }
    }

    //PS: Append ID on each data item
    this.data = this.data.map(x => { return { ...x, id }})

    this._element = cELM("div", "option-block");
    this.selectedOptions = [];
    this.noneAbove = null;
    this.createElement();
  }

  createElement() {
    const _self = this;
    const btnEl = cELM(
      "div",
      "continue-button",
      getLngTxt('button.continue')
    );
    const btnWrp = Wrap4Arrow(btnEl);
    
    
    if (this.options.selectAll) {
      const selectAll = cELM(
        "a",
        "select-all",
        this.options["selectAll"].label
      );
      this._element.addELM(selectAll);
      selectAll.onclick = () => {
        const allmeds = document.getElementsByClassName("option");
        for (let index = 0; index < allmeds.length; index++) {
          if (!allmeds[index].classList.contains("option-active"))
            allmeds[index].classList.add("option-active");
        }
      };
    }


    if (this.options.deselectAll) {
      const selectNone = cELM(
        "a",
        "deselect-all",
        this.options["deselectAll"].label
      );
      this._element.addELM(selectNone);
      selectNone.onclick = () => {
        const allmeds = document.getElementsByClassName("option");
        for (let index = 0; index < allmeds.length; index++) {
          if (allmeds[index].classList.contains("option-active"))
            allmeds[index].classList.remove("option-active");
        }
        btnEl.classList.add("continue-button-active");
        btnWrp.classList.add("arrow-active");
      };
    }

    let alreadyHighlighted = false;
    
    if ((this.options.yesToAll) && (this.data.length > 2)){
      let op = this.options.yesToAll.label.trim();
      
      const checkedYes = this.options.yesToAll.status.every(x => x === 'yes')
     
      let yesToAll = cELM("div", "option-check checkbox-option");

      yesToAll.innerHTML = '<div class="option-icon"></div><div class="option-text">' + op + "</div>";
     
      this._element.addELM(yesToAll);
      
      yesToAll.onclick = () => {
        _self.selectedOptions = [];
        var isActiveYes = yesToAll.getAttribute('status-box');
        var answerYes = document.getElementsByClassName('yes-no-option yes');
        var answerNo = document.getElementsByClassName('yes-no-option no')
        
        if(isActiveYes == 'yes'){
          yesToAll.classList.remove("option-active");
          yesToAll.setAttribute("status-box", 'no');
       
          for(var i = 0; i< answerYes.length; i++){
            answerYes[i].click();
          }
          
        }else{
          
          yesToAll.classList.toggle("option-active");
          yesToAll.setAttribute("status-box", 'yes');
        
          for (var i= 0; i < answerYes.length; i++){
            if(!answerYes[i].classList.contains('yes-no-option-active')){
              answerYes[i].click();
            }
            if(answerNo[i].classList.contains('yes-no-option-active')){
              answerNo[i].click()
            }
            
            
          }
          
          Scroller.smoothScrollTo(document.body.scrollHeight, 1000);

        }
      }

      if(checkedYes){
        setTimeout(() => {
          yesToAll.classList.toggle('option-active');
          yesToAll.setAttribute('status-box', 'yes');
        }, 10) 

      }
    
      
}

    for(var i = 0; i < this.data.length; i++){
      
      var item = this.data[i];
      let op =
        typeof item == "string" ? item : (item[this.labels[0]] || "").trim();

      const _el = cELM("div", "yes-no-block-item");
     

      _el.value = op;

      const yesNo = new YESNO(item.status ? item.status : "unknown", item);
      _el.setAttribute("status", item.status ? item.status : "unknown");
      _el.setAttribute("medication", item.medication);

      if(!alreadyHighlighted && (item.status != 'yes' && item.status != 'no')){
        alreadyHighlighted = true;
        yesNo.highlight(true);
      }

      let txt = item[this.labels[0]].replace(
        /\s(\d+.+)/,
        '<div class="subtext">$1</div>'
      );

      _el.yesNo = yesNo;

      for (let [index, label] of this.labels.entries()) {
        if (index != 0) {
          txt += item[label]
            ? '<div class=\"subtext\">'+item[label]+'</div>'
            : "";
        }
      }
      
      if(!alreadyHighlighted){
        btnWrp.classList.add("arrow-active");
        btnEl.classList.add("continue-button-active");
      }else{
        if(btnEl.classList.contains("continue-button-active")){
          btnWrp.classList.remove("arrow-active");
          btnEl.classList.remove("continue-button-active");
        }
      }

      const isNewlyAdded = item.isNewlyAdded;
      // if(!isNewlyAdded) {
      //   _el.addELM(yesNo);
      // }
      _el.addELM(cELM("div", "option-text", txt));

      //This is only for new? or the edit button can be applied to priormeds too?
      if(isNewlyAdded) {
        const editRmvOpts = Object.assign({}, { edit: "Edit", remove: isNewlyAdded ? 'Delete' : false }, (this.options || {}).editListOptions || {});
        const editRmvBlock = new EDITREMOVE(_self.id, item.medication, null, editRmvOpts);
        _el.addELM(editRmvBlock);
      } else {
        _el.addELM(yesNo);
      }
      this._element.addELM(_el);
    }

    this._element.nextHighlight = function(){

      alreadyHighlighted = false;
      for(var i = 0; i < this.childNodes.length; i ++){
        var nyn = this.childNodes[i];
        if(nyn.yesNo){
          let ynV = nyn.getAttribute("status");
          if((ynV != 'yes' && ynV != 'no' )&& !alreadyHighlighted){
            alreadyHighlighted = true;
            nyn.yesNo.highlight(true);
          }
          else
          {
            nyn.yesNo.highlight(false);
            
            }
          }
      }
      
      if(!alreadyHighlighted){
        btnWrp.classList.add("arrow-active");
        btnEl.classList.add("continue-button-active");
      }else{
        if(btnEl.classList.contains("continue-button-active")){
          btnWrp.classList.remove("arrow-active");
          btnEl.classList.remove("continue-button-active");
        }
      }

    }
    //add none of the above if needed
    if (this.options.noneOftheAbove) {
      const _el_none = cELM(
        "div",
        "option" + (this.labels.length > 1 ? " option-border" : "")
      );
      this.noneAbove = _el_none;
      const checkBox = cELM("div", "option-icon");
      const optionText = cELM(
        "div",
        "option-text",
        "<strong>None of the above</strong>"
      );
      _el_none.addELM(checkBox);
      _el_none.addELM(optionText);
      this._element.addELM(_el_none);
      _el_none.onclick = function() {
        _el_none.classList.toggle("option-active");

        const allmeds = document.getElementsByClassName("option");

        for (let index = 0; index < allmeds.length; index++) {
          if (
            allmeds[index].classList.contains("option-active") &&
            allmeds[index] != _el_none
          )
            allmeds[index].classList.remove("option-active");
        }
        btnEl.classList.add("continue-button-active");
        btnWrp.classList.add("arrow-active");
      };
    }

    btnWrp.onclick = function(evt) {
      if (btnEl.classList.contains("continue-button-active")) {
        btnEl.classList.remove("continue-button-active");
        btnWrp.classList.remove("arrow-active");
        btnWrp.style.display = "none";
        _self.selectedOptions = [];
        let sibling = btnWrp.parentNode.firstChild;
        while (sibling) {
          let medicationVal = sibling.getAttribute("medication");
          let ynValue = sibling.getAttribute("status");
          if (
            sibling.classList.contains("yes-no-block-item") &&
            medicationVal
          ) {
            _self.selectedOptions.push({
              medication: medicationVal,
              status: ynValue
            });
          }

          sibling = sibling.nextSibling;
        }
        
        Chat.default.update({ 
            ..._self.selectedOptions, 
            id: _self.id
          }, 
          null, 
          _self.element
        );
      }
    };
    if (this.options.button !== false) this._element.addELM(btnWrp);
  }

  getELM() {
    return this._element;
  }

  getHTML() {
    return this._element;
  }

  reset() {
    let sibling = this._element.firstChild;
    while (sibling) {
      sibling.classList.remove("option-active");
      sibling.classList.remove("continue-button-active");
      sibling.classList.remove("arrow-active");

      sibling = sibling.nextSibling;
    }
    this.selectedOptions = [];
  }

  focus() {}
}

module.exports = List;
